module.exports = __webpack_public_path__ + "static/assets/2ef4b2500143cfbf3650c301d1eb2210.png";